export function sessionFromApi(data, sessionId) {
  return {
    sessionId: sessionId || data?.sessionId,
    email: data?.email,
    userName: data?.userName,
    companyId: data?.companyId ?? null,
    companyName: data?.companyName ?? null,
    isAdmin: !!data?.isAdmin,
    isSuperAdmin: !!data?.isSuperAdmin
  };
}
